import React, {useState} from "react";
import {ArrowSmallUpIcon, ArrowSmallDownIcon, CursorArrowRippleIcon} from "@heroicons/react/24/solid";
import Modal from "../ui-components/Modal";
import Input from "../ui-components/Input";
import {CheckCircleIcon} from "@heroicons/react/24/outline";

const MoveBlock = ({moveBlock, block, position, listLength}) => {

  const [showMove, setShowMove] = useState(false);
  const [newVal, setNewVal] = useState(position);

  if (listLength < 2) {
    return null
  }

  return (
    <>
      <div className="flex flex-row justify-between mr-2">
        <div className="w-4 flex flex-col align-middle mr-2 text-center gap-y-1">
          <div className="opacity-50">
            {position}
          </div>
          <div className="cursor-pointer" onClick={(e) => {
            e.stopPropagation();
            setShowMove(true);
          }}>
            <CursorArrowRippleIcon/>
          </div>
        </div>
        <div className="flex flex-col justify-between mr-2">
          <div
            onClick={(e) => {
              e.stopPropagation();

              if (position === 0) {
                return;
              }
              moveBlock(block, position - 1, position);
            }}
            className={`w-5 h-5 cursor-pointer ${
              position === 0 ? "opacity-40" : ""
            }`}
          >
            <ArrowSmallUpIcon/>
          </div>
          <div
            onClick={(e) => {
              e.stopPropagation();
              if (position === listLength - 1) {
                return;
              }
              moveBlock(block, position + 1, position);
            }}
            className={`w-5 h-5 cursor-pointer ${
              position === listLength - 1 ? "opacity-40" : ""
            }`}
          >
            <ArrowSmallDownIcon/>
          </div>
        </div>
      </div>
      {showMove &&
        <Modal
          onExit={() => setShowMove(false)}
        >
          <div className="flex flex-row gap-5 mt-8 justify-center align-middle">
            <div className="mt-3">
              Move order into index
            </div>
            <div className="w-32">
              <Input
                type="number"
                value={newVal}
                onChange={(e) => setNewVal(e.target.value)}
              />
            </div>
            <div
              className="cursor-pointer mt-2"
              onClick={() => {
                moveBlock(block, newVal, position)
                setShowMove(false)
              }}>
              <CheckCircleIcon className="w-8 h-8" />
            </div>
          </div>
        </Modal>
      }
    </>
  );
};

export default MoveBlock;
